import "./index.css";

import React from 'react'

const HerbSponsoredBadge = () => {
  return (
    <div className="herbSponsoredBadge">
      <span className="badgeText">Herb Sponsor</span>
    </div>
  )
}

export default HerbSponsoredBadge
